import EnvConstants from 'app/services/core/config.service'

export const ROOT = EnvConstants.CKLA_URL
export const CKLA = `${ROOT}/ckla`
export const CKLA_HUB = `${ROOT}/ckla/hub`
export const CKLA_ASSETS = `${CKLA_HUB}/assets`
export const CKLA_PUBLIC_ASSETS = [
  'https://dam.amplify.com/m/7d04ba89e7c72bc6/original/ckla_hub_overview',
  'https://dam.amplify.com/m/61dd05b2c6cd7655/original/ckla_hub_overview',
  'https://dam.amplify.com/m/19eea4d251c9a1f0/original/ckla_hub_overview',
]
export const { VOCAB_URL } = EnvConstants
export const MULTIMEDIA_PATH = `${CKLA_ASSETS}/content/multimedia`
export const EBOOKS_IMAGE_PATH = `${CKLA_ASSETS}/multimediaEbooks/thumbs/`
export const CAMINOS_IMAGE_PATH = `${CKLA_ASSETS}/caminosReaders/thumbs/`

export const CKLA__HUB_FOLDER = `${CKLA_ASSETS}/ckla_hub`
export const CKLA_HUB_THEATRE = `${CKLA__HUB_FOLDER}/theatre`
export const CKLA_HUB_TEACHER_GUIDE = `${CKLA__HUB_FOLDER}/teacher_guide`
export const CKLA_HUB_TG_IMAGES = `${CKLA_HUB_TEACHER_GUIDE}/images`
export const CKLA_HUB_CAROUSEL_DATA = `${CKLA_HUB_TEACHER_GUIDE}/carousel_data`
export const GUIDES_PATH = `${CKLA__HUB_FOLDER}/guides`

export const ACCESS_DENIED_PATH = `/access-denied/2020-2021-ckla-grades-k-5`

export const PATHS = {
  SOUNDS: `${MULTIMEDIA_PATH}/sounds`,
  SONGS: `${MULTIMEDIA_PATH}/songs`,
  VIDEOS: `${MULTIMEDIA_PATH}/video`,
  CAMINOS_SOUNDS: `${MULTIMEDIA_PATH}/caminosSounds`,
  CAMINOS_SONGS: `${MULTIMEDIA_PATH}/songs`,
  CAMINOS_VIDEOS: `${MULTIMEDIA_PATH}/video`,
}

export const DATA_URL = {
  SOUNDS: `${CKLA_ASSETS}/multimediaSounds.json`,
  SONIDOS: `${CKLA_ASSETS}/multimediaCaminosSounds.json`,
  LIBRARY: `${CKLA_ASSETS}/multimediaEbooks/index.json`,
  LIBRARY3: `${CKLA_ASSETS}/multimediaEbooks/index.json`,
  BIBLIOTECA: `${CKLA_ASSETS}/spanishReaders/index.json`,
  CAMINOS: `${CKLA_ASSETS}/caminosReaders/index.json`,
  TEXAS_ELAR: `${CKLA_ASSETS}/texasElarReaders/index.json`,
  TEXAS_SLAR: `${CKLA_ASSETS}/texasSlarReaders/index.json`,
  KNOWLEDGEBUILDERS: `${CKLA_ASSETS}/knowledgeBuilders/index.json`,
  KNOWLEDGEBUILDERS_FL: `${CKLA_ASSETS}/knowledgeBuilders/index_fl.json`,
  KNOWLEDGE: (id: string) => `${CKLA_ASSETS}/knowledgeBuilders/${id}.json`,
}

export const READING_METAGAME_URL = `${EnvConstants.READING_ROOT_URL}/pub/pages/play.html?external_source=ckla`
export const READING_TD_URL = `${EnvConstants.READING_ROOT_URL}/educator/index.html?external_source=ckla`

export const CKLA_HUB_ANIMATION = `${CKLA_ASSETS}/ckla_hub/animation`

export const DEFAULT_CMS_REVISION = 'latest'
